import { render, staticRenderFns } from "./param-chirurgies.html?vue&type=template&id=3176e544&scoped=true&external"
import script from "./param-chirurgies.js?vue&type=script&lang=js&external"
export * from "./param-chirurgies.js?vue&type=script&lang=js&external"
import style0 from "./param-chirurgies.scss?vue&type=style&index=0&id=3176e544&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3176e544",
  null
  
)

export default component.exports